




























































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { ParceirosService, Parceiro } from "@/services/parceiros.service";
import { moeda, cpf } from "@/shared/filters";
import DataTable from "@/shared/components/data-table.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import Manter from "./Manter.vue";
import Saque from "./conta-corrente/Saque.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";

@Component({
  components: {
    DataTable,
    Manter,
    Saque,
    Tooltip,
    InputMoeda,
  },
  filters: { moeda, cpf },
})
export default class Parceiros extends mixins(GlobalMixin) {
  filters = {
    term: "",
    saldoMaiorQue: 0,
  };

  promise: Promise<Parceiro[]> | null = null;

  headers = [
    { value: "nome", text: "Parceiro" },
    { value: "cpf", text: "CPF" },
    { value: "pix", text: "Pix" },
    { value: "saldoAtual", text: "Saldo Atual" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  mounted() {
    this.fetchParceiros();
  }

  fetchParceiros() {
    this.promise = ParceirosService.listarParceiros(
      this.filters.term,
      this.filters.saldoMaiorQue
    );
  }
  async efetuarSaque(item: Parceiro) {
    const modal = this.$refs.saque as Saque;
    await modal.efetuarSaque(item.idConsultor);
    this.fetchParceiros();
  }
  async contaCorrente(item: Parceiro) {
    this.$router.push({
      name: "contacorrente",
      params: { idConsultor: String(item.idConsultor) },
    });
  }
  async novoItem() {
    const modal = this.$refs.manter as Manter;
    await modal.associarParceiro();
    this.fetchParceiros();
  }
}
